import { Control } from '@Common/Controls/Controls';
import { ISpinnerContainer, ISpinnerSetting } from '@Common/Plugins/spinner';

export interface IAsyncWaiterSetting {
    showError?: boolean;
    setting?: ISpinnerSetting;
    control: Control | ISpinnerContainer;
}

export type AwaiterHandler<T = any> = PromiseLike<T> | (() => PromiseLike<T>);

export type AsyncWaiter = (awaiter: AwaiterHandler) => void;

export function asyncWaiter(awaiter: AwaiterHandler, setting: IAsyncWaiterSetting): void;
export function asyncWaiter<T>(awaiter: AwaiterHandler<T>, setting: IAsyncWaiterSetting, returnPromise: true): PromiseLike<T>;
export function asyncWaiter(
    awaiter: AwaiterHandler,
    { showError = true, control, setting }: IAsyncWaiterSetting,
    returnPromise: boolean = false
): PromiseLike<any> {
    const element = isSpinnerContainer(control) ? control : control.getControl();
    const promise = Function.isFunction(awaiter) ? awaiter() : awaiter;
    element.spinnerStart(setting);
    const res = promise
        .then(_.identity, error => showError && console.error(error))
        .then(res => {
            element.spinnerStop();
            return res;
        });
    return returnPromise && res;
}

function isSpinnerContainer(elem: any): elem is ISpinnerContainer {
    return elem && Function.isFunction(elem.spinnerStart);
}
